export default "__VITE_ASSET__orV7SEOn__"